module.exports = __webpack_public_path__ + "img/tv_dark.9e09de36.svg";